import { render, staticRenderFns } from "./col-sctz38.vue?vue&type=template&id=a57e4596&scoped=true&"
import script from "./col-sctz38.vue?vue&type=script&lang=js&"
export * from "./col-sctz38.vue?vue&type=script&lang=js&"
import style0 from "./col-sctz38.vue?vue&type=style&index=0&id=a57e4596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57e4596",
  null
  
)

component.options.__file = "col-sctz38.vue"
export default component.exports